import { cn } from "@/lib/utils";

export type SelectionOutlineOpts = {
  /** Kijelölt sornál / cellánál enyhe háttér (táblázat, sűrű lista) */
  denseSelectedBg?: boolean;
};

/**
 * Egységes „bal csíkos” kijelölés-vizuál kijelölés módban:
 * mindig `border-l-4`, kijelölt: `border-l-primary`, egyébként `border-l-transparent` (layout shift nélkül).
 */
export function selectionItemOutlineClasses(
  selectionMode: boolean,
  selected: boolean,
  opts?: SelectionOutlineOpts,
): string {
  if (!selectionMode) return "";
  return cn(
    "border-l-4",
    selected ? "border-l-primary" : "border-l-transparent",
    opts?.denseSelectedBg && selected && "bg-muted/20",
  );
}
